(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/selectors/engine-selectors.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/selectors/engine-selectors.js'); "use strict";

var _svs$core$config$data, _svs$core$config$data2;
const {
  selectCompetitionDetails,
  selectActiveCompetitionId
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  SYSTEM_MSYS,
  SYSTEM_RSYS
} = svs.components.tipsen.engine.constants.systems;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const PixSystem = svs.components.tipsen.engine.constants.PixSystem;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  externalSystemsBoardsType
} = svs.components.tipsen.engine.constants;
const {
  userSession
} = svs.core;
const tipsinfo = svs.components.tipsen.engine.constants.tipsinfo;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const isRetailer = userSession.hasRole(userSession.roles.RETAILER);
const selectBetAmounts = state => {
  var _selectEngineDefiniti;
  return (_selectEngineDefiniti = selectEngineDefinition(state).betAmounts) !== null && _selectEngineDefiniti !== void 0 ? _selectEngineDefiniti : [];
};
const selectRSystems = state => {
  var _selectEngineDefiniti2;
  return (_selectEngineDefiniti2 = selectEngineDefinition(state).rSystems) !== null && _selectEngineDefiniti2 !== void 0 ? _selectEngineDefiniti2 : [];
};
const selectUSystems = state => {
  var _selectEngineDefiniti3;
  return (_selectEngineDefiniti3 = selectEngineDefinition(state).uSystems) !== null && _selectEngineDefiniti3 !== void 0 ? _selectEngineDefiniti3 : [];
};
const selectSystemTypes = state => {
  var _selectEngineDefiniti4;
  return (_selectEngineDefiniti4 = selectEngineDefinition(state).systems) !== null && _selectEngineDefiniti4 !== void 0 ? _selectEngineDefiniti4 : [];
};
const selectWeeks = state => {
  var _selectEngineDefiniti5;
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails) {
    return [];
  }
  return (_selectEngineDefiniti5 = selectEngineDefinition(state).weeks) !== null && _selectEngineDefiniti5 !== void 0 ? _selectEngineDefiniti5 : [];
};
const selectAddonPixSizes = state => {
  var _selectEngineDefiniti6;
  return (_selectEngineDefiniti6 = selectEngineDefinition(state).addonPixSize) !== null && _selectEngineDefiniti6 !== void 0 ? _selectEngineDefiniti6 : [];
};
const selectSportkryssFactors = state => {
  var _selectEngineDefiniti7;
  return (_selectEngineDefiniti7 = selectEngineDefinition(state).sportkryssFactors) !== null && _selectEngineDefiniti7 !== void 0 ? _selectEngineDefiniti7 : [];
};
const selectSportkryssBase = state => {
  var _selectEngineDefiniti8;
  return (_selectEngineDefiniti8 = selectEngineDefinition(state).sportkryssBase) !== null && _selectEngineDefiniti8 !== void 0 ? _selectEngineDefiniti8 : 0;
};
const selectDrawProductIds = state => {
  var _selectEngineDefiniti9;
  return (_selectEngineDefiniti9 = selectEngineDefinition(state).drawProductIds) !== null && _selectEngineDefiniti9 !== void 0 ? _selectEngineDefiniti9 : [];
};
const selectBrandName = state => selectEngineDefinition(state).brandName;
const selectDisplayName = state => selectEngineDefinition(state).displayName;
const selectXpertMsys = state => {
  var _selectEngineDefiniti10;
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails && competitionDetails.systemType === SYSTEM_MSYS) {
    return [competitionDetails.systemNumber];
  }
  return (_selectEngineDefiniti10 = selectEngineDefinition(state).xpertMsys) !== null && _selectEngineDefiniti10 !== void 0 ? _selectEngineDefiniti10 : [];
};
const selectXpertMsysSpecialValues = state => selectEngineDefinition(state).xpertMsysSpecialValues;
const selectQuickPlayPixSizes = state => selectEngineDefinition(state).quickPlayPixSizes;
const selectDefinitionId = state => state.Module.engine;
const selectMaxExternalSystemSize = state => selectEngineDefinition(state).maxExternalSystemSize;
const selectMinStake = state => selectEngineDefinition(state).minStake;
const selectFeatureStandard = state => {
  var _selectEngineDefiniti11, _selectEngineDefiniti12;
  return (_selectEngineDefiniti11 = (_selectEngineDefiniti12 = selectEngineDefinition(state).features) === null || _selectEngineDefiniti12 === void 0 ? void 0 : _selectEngineDefiniti12.standard) !== null && _selectEngineDefiniti11 !== void 0 ? _selectEngineDefiniti11 : true;
};
const selectFeatureSystem = state => selectRSystems(state).length > 0 || selectUSystems(state).length > 0;
const selectFeaturePix = state => {
  var _selectEngineDefiniti13;
  return !isRetailer && !((_selectEngineDefiniti13 = selectEngineDefinition(state).features) !== null && _selectEngineDefiniti13 !== void 0 && _selectEngineDefiniti13.pix) && true;
};
const selectFeatureMarketplace = state => {
  var _selectEngineDefiniti14, _selectEngineDefiniti15;
  return !isRetailer && !isSelfService && ((_selectEngineDefiniti14 = (_selectEngineDefiniti15 = selectEngineDefinition(state).features) === null || _selectEngineDefiniti15 === void 0 ? void 0 : _selectEngineDefiniti15.marketplace) !== null && _selectEngineDefiniti14 !== void 0 ? _selectEngineDefiniti14 : false);
};
const selectFeatureSingles = state => {
  var _selectEngineDefiniti16, _selectEngineDefiniti17;
  return (_selectEngineDefiniti16 = (_selectEngineDefiniti17 = selectEngineDefinition(state).features) === null || _selectEngineDefiniti17 === void 0 ? void 0 : _selectEngineDefiniti17.singles) !== null && _selectEngineDefiniti16 !== void 0 ? _selectEngineDefiniti16 : false;
};
const selectFeatureExternal = state => !isRetailer && !isSelfService && selectMaxExternalSystemSize(state) > 0 && svs.core.detect.feature('ft-tipsen-externa');
const selectXpertRsys = state => {
  var _selectEngineDefiniti18;
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails && competitionDetails.systemType === SYSTEM_RSYS) {
    return [competitionDetails.systemNumber]; 
  }

  return (_selectEngineDefiniti18 = selectEngineDefinition(state).pixSystems) !== null && _selectEngineDefiniti18 !== void 0 ? _selectEngineDefiniti18 : [];
};
const selectDefaultPixSize = state => {
  var _selectEngineDefiniti19, _selectEngineDefiniti20;
  return (_selectEngineDefiniti19 = (_selectEngineDefiniti20 = selectEngineDefinition(state).defaultCouponValues) === null || _selectEngineDefiniti20 === void 0 ? void 0 : _selectEngineDefiniti20.pixSize) !== null && _selectEngineDefiniti19 !== void 0 ? _selectEngineDefiniti19 : null;
};
const selectDefaultReduceModeCount = state => {
  var _selectEngineDefiniti21, _selectEngineDefiniti22;
  return (_selectEngineDefiniti21 = (_selectEngineDefiniti22 = selectEngineDefinition(state).defaultCouponValues) === null || _selectEngineDefiniti22 === void 0 ? void 0 : _selectEngineDefiniti22.reduceModeCount) !== null && _selectEngineDefiniti21 !== void 0 ? _selectEngineDefiniti21 : undefined;
};
const selectIsTipsinfoSupported = (state, tipsinfo, isResult) => {
  if (selectEngineDefinition(state).tipsinfoSupportResult && isResult) {
    return selectEngineDefinition(state).tipsinfoSupportResult.includes(tipsinfo);
  } else if (selectEngineDefinition(state).tipsinfoSupport) {
    return selectEngineDefinition(state).tipsinfoSupport.includes(tipsinfo);
  }
  return false;
};
const selectTipsinfoSupport = function (state) {
  let isResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    [tipsinfo.Odds]: selectIsTipsinfoSupported(state, tipsinfo.Odds, isResult),
    [tipsinfo.StartOdds]: selectIsTipsinfoSupported(state, tipsinfo.StartOdds, isResult),
    [tipsinfo.SvenskaFolket]: selectIsTipsinfoSupported(state, tipsinfo.SvenskaFolket, isResult),
    [tipsinfo.TioTidningar]: selectIsTipsinfoSupported(state, tipsinfo.TioTidningar, isResult),
    [tipsinfo.Matchstart]: selectIsTipsinfoSupported(state, tipsinfo.Matchstart, isResult),
    [tipsinfo.Favourites]: selectIsTipsinfoSupported(state, tipsinfo.Favourites, isResult),
    [tipsinfo.Mutuals]: selectIsTipsinfoSupported(state, tipsinfo.Mutuals, isResult),
    [tipsinfo.Analys]: selectIsTipsinfoSupported(state, tipsinfo.Analys, isResult),
    [tipsinfo.Marks]: true
  };
};
const selectOutcomesEventTypeId = state => {
  var _selectEngineDefiniti23, _selectEngineDefiniti24;
  return (_selectEngineDefiniti23 = (_selectEngineDefiniti24 = selectEngineDefinition(state).outcomes) === null || _selectEngineDefiniti24 === void 0 ? void 0 : _selectEngineDefiniti24.eventTypeId) !== null && _selectEngineDefiniti23 !== void 0 ? _selectEngineDefiniti23 : EventTypeId.EVENT_1X2;
};
const selectPixSystem = state => {
  var _selectEngineDefiniti25, _selectEngineDefiniti26;
  return (_selectEngineDefiniti25 = (_selectEngineDefiniti26 = selectEngineDefinition(state)) === null || _selectEngineDefiniti26 === void 0 ? void 0 : _selectEngineDefiniti26.pixSystem) !== null && _selectEngineDefiniti25 !== void 0 ? _selectEngineDefiniti25 : PixSystem.Xperten;
};
const selectExternalSystemChunkSize = (state, boardType, isMarketPlace) => {
  const {
    externalChunkSize: {
      SROW,
      MSYS,
      SROW_MARKETPLACE_GROUP,
      MSYS_MARKETPLACE_GROUP
    }
  } = selectEngineDefinition(state);
  if (boardType === externalSystemsBoardsType.single) {
    return isMarketPlace ? SROW_MARKETPLACE_GROUP : SROW;
  }
  return isMarketPlace ? MSYS_MARKETPLACE_GROUP : MSYS;
};
setGlobal('svs.components.tipsen.engine.selectors.engineSelectors', {
  selectBetAmounts,
  selectBrandName,
  selectDisplayName,
  selectRSystems,
  selectUSystems,
  selectWeeks,
  selectSportkryssFactors,
  selectSportkryssBase,
  selectSystemTypes,
  selectDrawProductIds,
  selectXpertMsys,
  selectDefinitionId,
  selectMaxExternalSystemSize,
  selectFeatureStandard,
  selectFeatureSystem,
  selectFeaturePix,
  selectFeatureMarketplace,
  selectFeatureSingles,
  selectFeatureExternal,
  selectMinStake,
  selectXpertRsys,
  selectIsTipsinfoSupported,
  selectTipsinfoSupport,
  selectXpertMsysSpecialValues,
  selectQuickPlayPixSizes,
  selectDefaultPixSize,
  selectDefaultReduceModeCount,
  selectOutcomesEventTypeId,
  selectPixSystem,
  selectExternalSystemChunkSize,
  selectAddonPixSizes
});
 })(window);